import React from "react";
import OnboardingLayout from "@components/onboarding/onboarding_layout";

const OnboardingSubmit = () => {
  return null;
};

OnboardingSubmit.layout = (page: React.ReactNode) => <OnboardingLayout>{page}</OnboardingLayout>;

export default OnboardingSubmit;
